// extracted by mini-css-extract-plugin
export var isPrintedCell = "_x2-1";
export var printerIcon = "_x2-0";